import { render, staticRenderFns } from "./LoldocupResult.vue?vue&type=template&id=a3c3745c&"
import script from "./LoldocupResult.vue?vue&type=script&lang=js&"
export * from "./LoldocupResult.vue?vue&type=script&lang=js&"
import style0 from "./LoldocupResult.vue?vue&type=style&index=0&id=a3c3745c&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports